export const translations = {
  sv: {
    searchlabel: 'Sök',
    searchplaceholder: 'Vad letar du efter?',
    searchbuttontext: 'Sök',
    menuHomeButton: 'Hem',
    menuGoBackButton: 'Gå tillbaka',
    mainMenuButton: 'Meny',
    menuStartButton: 'Start',
  },
  en: {
    searchlabel: 'Search',
    searchplaceholder: 'Search',
    searchbuttontext: 'Search',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
  },
  da: {
    searchlabel: 'Søg',
    searchplaceholder: 'Søg',
    searchbuttontext: 'Søg',
    menuHomeButton: 'Hjem',
    menuGoBackButton: 'Gå tilbage',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
  },
  no: {
    searchlabel: 'Søk',
    searchplaceholder: 'Søk',
    searchbuttontext: 'Søk',
    menuHomeButton: 'Hjem',
    menuGoBackButton: 'Gå tilbake',
    mainMenuButton: 'Meny',
    menuStartButton: 'Start',
  },
  fi: {
    searchlabel: 'Hae',
    searchplaceholder: 'Hae',
    searchbuttontext: 'Hae',
    menuHomeButton: 'Koti',
    menuGoBackButton: 'Mene takaisin',
    mainMenuButton: 'Valikko',
    menuStartButton: 'Alkaa',
  },
  zh: {
    searchlabel: 'Search',
    searchplaceholder: 'Search',
    searchbuttontext: 'Search',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
  },
  it: {
    searchlabel: 'Search',
    searchplaceholder: 'Search',
    searchbuttontext: 'Search',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
  },
  nl: {
    searchlabel: 'Search',
    searchplaceholder: 'Search',
    searchbuttontext: 'Search',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
  },
};
